module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./node_modules/readable-stream/lib/internal/streams/stream-browser.js
// module id = 79
// module chunks = 0 1


// WEBPACK FOOTER //
// webpack:///node_modules/readable-stream/lib/internal/streams/stream-browser.js